import { render } from "./App.vue?vue&type=template&id=10a79b22&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=10a79b22&lang=scss"

import exportComponent from "/Users/olimago/Documents/www/escape-if-you-can-01/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__